import { GET_CLAIM_DETAILS_FROM_NEW_GRID_URL,  GET_LOG_DETAILS_FROM_NEW_GRID_URL, GET_PLB_DETAILS_FROM_NEW_GRID_URL } from "../../api/commonRoutepath";
import request from "../../api/agent";



export const getPlbDetailsFromNewGrid = async (payload) => {
    const response = await request.post(GET_PLB_DETAILS_FROM_NEW_GRID_URL, payload);
    return response?.data;

};



export const getClaimDetailsFromNewGrid = async (payload) => {
    const response = await request.post(GET_CLAIM_DETAILS_FROM_NEW_GRID_URL, payload);
    return response?.data;

};

export const getAllLogDetails = async (payload) => {
    // Build query parameters dynamically
    const params = new URLSearchParams();
    
    // Always include data_type and job_log
    if (payload?.data_type) {
        params.append('data_type', payload.data_type);
    }
    if (payload?.job_log) {
        params.append('job_log', payload.job_log);
    }
    
    // Conditionally include page and limit if they exist
    if (payload?.page) {
        params.append('page', payload.page);
    }
    if (payload?.limit) {
        params.append('limit', payload.limit);
    }
    // Conditionally include page and limit if they exist
    if (payload?.from) {
        params.append('claim_from', payload.from);
    }
    if (payload?.to) {
        params.append('claim_to', payload.to);
    }
    params.append('is_view_history', payload.is_view_history);

    const response = await request.get(`${GET_LOG_DETAILS_FROM_NEW_GRID_URL}?${params.toString()}`);
    return response?.data;
};

export const fetchLogAllJobDetails = async (job_log,log_id) => {
  try {
    let current_job = job_log
    let is_view_history = false
    if(log_id){
        current_job = log_id
        is_view_history = true
    }
    // 1. Get Job Details
    const jobData = await getAllLogDetails({ data_type:"1",job_log:current_job,is_view_history});
    if(jobData?.status===false){
        return jobData
    }
    // If jobData is not valid, this will not run (because of the throw above)
    const { job ,grid_clm_limit} = jobData.data;

    // 2. Get Header Details
    const headerData = await getAllLogDetails({ data_type:"2",job_log:current_job,is_view_history});
    if(headerData?.status===false){
        return headerData
    }
    // 3. Get PLB Details
    const plbData = await getAllLogDetails({ data_type:"3",job_log:current_job,is_view_history,page:1,limit:15});
    if(plbData?.status===false){
        return plbData
    }
    // 4. Get Claim Details (GET)
    const claimData = await getAllLogDetails({ data_type:"4",job_log:current_job,is_view_history, page: 1, limit: grid_clm_limit });
    const {claims_total_amounts = [],...restClaim} = claimData?.data
    // Return all data

    return {
      ...jobData.data,
      claims_total_amounts,
      grid_data:{...headerData?.data,...plbData?.data,...restClaim}
    };
  } catch (error) {
    // Here, error will be your error object from the API
    // You can handle it or re-throw
    // For example, you can return a custom error object:
    console.error(error)
    return {
      status: false,
      message: error.message || error.errors || "Unknown error",
      details: error
    };
  }
};
export const fetchAllJobDetails = async (params) => {
 
    
   
};

export const finalSubmitJobDetailsSequential = async (params) => {
  
};

export const verificationJobUser1 = async (task_type, job_id) => {
 
};

export const updateJobUserStartTime1 = async (task_type, job_id) => {
  
};

export const createPropCode1 = async () => {

};

export const getGridNewOrOld = async () => {

};